/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem, SearchableSelectionType } from "./interface";



export class Ibis implements SearchableItem {
  ID: string;
  CODE: string;
  NAME: string;
  EDITABLE: boolean;

  // Helpers
  DATE: string = '';
  EXISTS: boolean = null;
  isLoading: boolean = false;
  isProcessed: boolean = false;
  active = false;
  selected = false;
  allowed: boolean;

  constructor(values: any = {}) {
    Object.assign(this, values);
  }

  static parseArray(json: any[]): Ibis[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new Ibis(j));
        }
      }
    }
    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return `${this.CODE} - ${this.NAME}`;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
